/**
 * Catalog config barrel — ported from LooksLab-Prod's src/config/index.js so
 * components lifted from Prod (ProductCard, ProductVariantSizeChips, etc.)
 * resolve `../config` imports unchanged.
 */

export const brand = {
  colors: {
    bg: '#0a0a0a',
    bgAlt: '#111111',
    bgCard: '#171717',
    border: '#2a2a2a',
    borderHover: '#404040',
    accent: '#e8e8e8',
    accentDim: '#8a8a8a',
    accentGlow: 'rgba(255, 255, 255, 0.07)',
    textPrimary: '#fafafa',
    textSecondary: '#a3a3a3',
    textMuted: '#525252',
    white: '#ffffff',
    labelInk: '#0a0a0a',
    labelSlate: '#737373',
    liquidFill: 'rgba(200, 200, 208, 0.38)',
    liquidMeniscus: 'rgba(230, 230, 235, 0.5)',
    glassEdge: 'rgba(255, 255, 255, 0.2)',
    glassShade: 'rgba(255, 255, 255, 0.06)',
    glassFadeCenter: 'rgba(255, 255, 255, 0.02)',
    glassBodySheen: 'rgba(255, 255, 255, 0.04)',
    neckFadeEnd: 'rgba(255, 255, 255, 0.04)',
    neckBodyFill: 'rgba(255, 255, 255, 0.03)',
    metalDark: '#2a2a2a',
    metalMid: '#9ca3af',
    rubber: '#1a1a1a',
    vialFlipCap: '#4a4a4a',
    vialFlipCapHighlight: '#6a6a6a',
    vialGlassMain: 'rgba(248, 250, 252, 0.11)',
    vialGlassDeep: 'rgba(200, 210, 225, 0.08)',
    vialCrimpShadow: 'rgba(0, 0, 0, 0.32)',
    vialShadow: 'rgba(0, 0, 0, 0.28)',
    vialGlassFace: 'rgba(225, 232, 240, 0.55)',
    vialGlassFaceRight: 'rgba(180, 192, 206, 0.5)',
    vialGlassHighlight: 'rgba(255, 255, 255, 0.75)',
    vialNeckGlass: 'rgba(210, 218, 228, 0.65)',
    vialLiquidBulk: 'rgba(155, 168, 182, 0.72)',
    vialLiquidTop: 'rgba(120, 132, 148, 0.85)',
    vialCapCylinderLight: '#b4b4b4',
    vialCapCylinderMid: '#7a7a7a',
    vialCapCylinderDark: '#4f4f4f',
    vialCapTopRing: '#c8c8c8',
    vialCapInset: '#2c2c2c',
    vialLabelBand: '#3d3d3d',
    vialLabelRule: '#8a8a8a',
    vialBaseMass: 'rgba(165, 178, 192, 0.55)',
    vialStopperFace: '#c8c8c8',
    headerBarBg: 'rgba(23, 23, 23, 0.78)',
    headerBarBgElevated: 'rgba(17, 17, 17, 0.94)',
    headerShadow: '0 10px 40px rgba(0, 0, 0, 0.45)',
    headerInnerHighlight: 'inset 0 1px 0 rgba(255, 255, 255, 0.06)',
    headerDivider: 'rgba(255, 255, 255, 0.12)',
  },
  fonts: {
    heading: "'Inter', 'Helvetica Neue', sans-serif",
    body: "'Inter', 'Helvetica Neue', sans-serif",
    mono: "'JetBrains Mono', 'Courier New', monospace",
  },
  radii: {
    sm: '6px',
    md: '12px',
    lg: '20px',
    pill: '999px',
  },
  spacing: {
    sectionPad: '120px 0',
    containerMax: '1160px',
    heroFill: 'calc(100svh - 7.5rem)',
  },
}

export * from './catalog.js'
export * from './productUtils.js'
